<template>
  <v-app>
    <v-main>
      <v-container>
        <v-layout justify-center>
          <v-flex xs12 sm12 md12 lg12 xl6>
            <v-card-title class="pb-5">
              <!--                                    v-if="$can('transaction_create')"-->
              <!--              <v-btn @click="$router.push({name: 'admin.customers'})" class="btn-back">-->
              <!--                <span class="flaticon2-reply icon-lg"></span>-->
              <!--                بازگشت-->
              <!--              </v-btn>-->
              <!--              <v-spacer/>-->
              <!--              {{ $t($route.meta.title) }}-->
              <!--              <v-spacer/>-->
              <v-btn @click="addCustomer" :loading="loading" class="submit-btn">
                <span class="fa fa-bookmark icon-md ml-1"></span>
                ذخیره
              </v-btn>
              <!--                            <v-card elevation="2" outlined>-->
            </v-card-title>
            <v-card-text>
              <hr class="pb-3" />
              <v-row>
                <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                  <v-text-field
                    label="نام"
                    outlined
                    dense
                    v-model="data.first_name"
                    counter
                    maxlength="30"
                    @keydown="isStringKey"
                    :error-messages="errors.first_name"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                  <v-text-field
                    label="نام خانوادگی"
                    outlined
                    dense
                    v-model="data.last_name"
                    counter
                    maxlength="60"
                    @keydown="isStringKey"
                    :error-messages="errors.last_name"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                  <v-text-field
                    label="نام پدر"
                    outlined
                    dense
                    v-model="data.fathers_name"
                    counter
                    maxlength="40"
                    @keydown="isStringKey"
                    :error-messages="errors.fathers_name"
                  ></v-text-field>
                </v-flex>
              </v-row>
              <v-row>
                <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                  <v-text-field
                    label="شغل"
                    outlined
                    dense
                    v-model="data.job"
                    :error-messages="errors.job"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                  <v-text-field
                    type="text"
                    counter
                    maxlength="10"
                    label="کدملی"
                    outlined
                    dense
                    v-model="data.national_code"
                    @keydown="isNumericKey"
                    :rules="rules.national_code"
                    :error-messages="errors.national_code"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                  <v-text-field
                    label="شماره شناسنامه"
                    outlined
                    dense
                    v-model.number="data.verify_id"
                    :rules="rules.isInt"
                    @keydown="isNumericKey"
                    maxlength="10"
                    counter
                    :error-messages="errors.verify_id"
                  ></v-text-field>
                  <!--                  v-model="data.verify_id"-->
                </v-flex>
              </v-row>
              <v-row>
                <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                  <v-text-field
                    label="شماره تلفن"
                    outlined
                    dense
                    v-model="data.telephone"
                    maxlength="11"
                    counter
                    :rules="rules.isInt"
                    @keydown="isNumericKey"
                    :error-messages="errors.telephone"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                  <date-picker
                    label="تاریخ تولد"
                    view="year"
                    format="YYYY-MM-DD"
                    display-format="jYYYY-jMM-jDD"
                    max="2006-01-01"
                    start="2006-01-01"
                    v-model="data.birth_day"
                  />
                </v-flex>
                <v-flex xs12 sm12 md4 lg4 xl4 class="p-2">
                  <v-text-field
                    label="محل تولد"
                    outlined
                    dense
                    v-model="data.place_birth"
                    :error-messages="errors.place_birth"
                  ></v-text-field>
                </v-flex>
              </v-row>
              <v-row>
                <v-flex class="p-2 d-flex d-inline" xs12 sm12 md4 lg4 xl4>
                  <v-autocomplete
                    :items="provinces"
                    item-text="name"
                    v-model="data.province"
                    :error-messages="errors.province"
                    item-value="id"
                    label="استان"
                    dense
                    outlined
                  >
                    <template slot="item" slot-scope="{ item }">{{
                      item.name
                    }}</template>
                  </v-autocomplete>
                </v-flex>
                <v-flex class="p-2 d-flex d-inline" xs12 sm12 md4 lg4 xl4>
                  <v-text-field
                    label="شماره موبایل"
                    outlined
                    dense
                    v-model="data.phone_number"
                    maxlength="11"
                    counter
                    :rules="rules.isInt"
                    @keydown="isNumericKey"
                    :error-messages="errors.phone_number"
                  ></v-text-field>
                  <v-btn
                    icon
                    v-if="!showOtherPhone"
                    rounded
                    class="mr-2 btn-add-with-text"
                    style="top: -9px !important"
                    @click="showOtherPhone = !showOtherPhone"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex
                  v-if="showOtherPhone"
                  class="p-2 d-flex d-inline"
                  xs12
                  sm12
                  md4
                  lg4
                  xl4
                >
                  <v-text-field
                    label="شماره دیگر"
                    outlined
                    dense
                    v-model="data.other_phone"
                    maxlength="11"
                    counter
                    :rules="rules.isInt"
                    @keydown="isNumericKey"
                    :error-messages="errors.other_phone"
                  ></v-text-field>
                  <v-btn
                    icon
                    @click="showOtherPhone = !showOtherPhone"
                    rounded
                    class="mr-2 btn-exit"
                    style="top: -9px !important"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-flex>
              </v-row>
              <v-row>
                <v-flex class="p-2" xs12 sm12 md6 lg6 xl6>
                  <v-textarea
                    label="آدرس"
                    outlined
                    dense
                    v-model="data.address"
                    :error-messages="errors.address"
                  ></v-textarea>
                </v-flex>
                <v-flex class="p-2" xs12 sm12 md6 lg6 xl6>
                  <v-textarea
                    label="توضیحات"
                    outlined
                    dense
                    v-model="data.description"
                    @keydown="isStringKey"
                    :error-messages="errors.description"
                  ></v-textarea>
                </v-flex>
              </v-row>
            </v-card-text>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Provinces from "@/Provinces.json";

export default {
  name: "Create",
  data() {
    return {
      loading: false,
      errors: [],
      provinces: [],
      rules: {
        national_code: [
          (val) =>
            !val ||
            this.checkNationalCode(this.english(val)) ||
            "کد ملی اشتباه است.",
        ],
        isInt: [(val) => !val || Number(val.toString()) || "فقظ عدد وارد کنید"],
      },
      showOtherPhone: false,
      data: {
        first_name: null,
        last_name: null,
        fathers_name: null,
        job: null,
        province: null,
        national_code: null,
        address: null,
        place_birth: null,
        birth_day: null,
        phone_number: null,
        other_phone: null,
        telephone: null,
        description: null,
      },
    };
  },
  mounted() {
    this.provinces = Provinces;
  },
  methods: {
    checkNationalCode(code) {
      var xv = code;
      if (isNaN(xv)) {
        return false;
      } else if (xv == "") {
        return false;
      } else if (xv.length < 10) {
        return false;
      } else {
        var yy = 0;
        var yv = parseInt(yv);
        for (let i = 0; i < xv.length; i++) {
          yv = xv[i] * (xv.length - i);
          yy += yv;
        }
        var x = yy % 11;
        if (x === 0) {
          return true;
        } else {
          return false;
        }
        yy = 0;
      }
    },
    addCustomer() {
      this.$modal.showLoading();
      this.loading = true;
      this.requestApiPost("customers", { ...this.data })
        .then(({ data }) => {
          this.$modal.hideLoading();
          this.$router.push({ name: "admin.customers" });
          this.$toast.success("مشتری با موفقیت اضافه شد.");
        })
        .catch(({ response }) => {
          this.loading = false;
          this.$modal.hideLoading();
          this.errors = response.data.errors;
        });
    },
  },
};
</script>

<style scoped></style>
